/* assets/pdpc-cards.js — "Add to compare" on product cards + floating Compare pill.
   Shares the localStorage compare lists (cmpx:v1:{category}) with the PDP modal.
   Loaded site-wide; only acts where [data-cmpx-card-add] cards exist. */
(function(){
  if(window.__cmpxCards) return; window.__cmpxCards=true;
  var LS='cmpx:v1:';
  function lsGet(c){ try{ var a=JSON.parse(localStorage.getItem(LS+c)||'[]'); return Array.isArray(a)?a:[]; }catch(e){ return []; } }
  function lsSet(c,a){ try{ localStorage.setItem(LS+c, JSON.stringify(a.slice(0,12))); }catch(e){} }
  function lsToggle(c,h){ var a=lsGet(c); var i=a.indexOf(h); if(i>-1) a.splice(i,1); else a.unshift(h); lsSet(c,a); return a.indexOf(h)>-1; }
  function lastSet(h){ try{ localStorage.setItem(LS+'last', h||''); }catch(e){} }
  function lastGet(){ try{ return localStorage.getItem(LS+'last')||''; }catch(e){ return ''; } }
  function pageCats(){ var s={}, b=document.querySelectorAll('[data-cmpx-card-add]'); for(var i=0;i<b.length;i++) s[b[i].getAttribute('data-cmpx-category')]=1; return Object.keys(s); }
  function total(){ var c=pageCats(), n=0; for(var i=0;i<c.length;i++) n+=lsGet(c[i]).length; return n; }
  function updateCards(){
    var b=document.querySelectorAll('[data-cmpx-card-add]');
    for(var i=0;i<b.length;i++){ var el=b[i], c=el.getAttribute('data-cmpx-category'), h=el.getAttribute('data-cmpx-handle');
      var added=lsGet(c).indexOf(h)>-1;
      el.classList.toggle('is-added',added); el.setAttribute('aria-pressed',added?'true':'false');
      var l=el.querySelector('[data-pcc-label]'); if(l) l.textContent=added?'In compare list':'Add to compare';
    }
  }
  function updateBars(){
    var r=document.querySelectorAll('.cmpx[data-cmpx-category]');
    for(var i=0;i<r.length;i++){ var root=r[i], c=root.getAttribute('data-cmpx-category'), cnt=root.querySelector('[data-cmpx-count]');
      if(cnt){ var n=lsGet(c).length; cnt.textContent=n>0?(' ('+n+')'):''; } }
  }
  var pill;
  function updatePill(){
    if(!document.querySelector('[data-cmpx-card-add]')) return;
    if(!pill){
      pill=document.createElement('button'); pill.type='button'; pill.className='cmpx-pill';
      pill.innerHTML='View comparison <span class="n" data-cmpx-pilln></span>';
      document.body.appendChild(pill);
      pill.addEventListener('click',function(){
        var h=lastGet();
        if(!h){ var cs=pageCats(); for(var i=0;i<cs.length&&!h;i++){ var a=lsGet(cs[i]); if(a.length) h=a[0]; } }
        if(h) location.href='/products/'+h+'?cmpx=open';
      });
    }
    var n=total(); var nn=pill.querySelector('[data-cmpx-pilln]'); if(nn) nn.textContent=n;
    pill.classList.toggle('on', n>=2);
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest && e.target.closest('[data-cmpx-card-add]'); if(!b) return;
    e.preventDefault();
    var c=b.getAttribute('data-cmpx-category'), h=b.getAttribute('data-cmpx-handle');
    var added=lsToggle(c,h); if(added) lastSet(h);
    updateCards(); updateBars(); updatePill();
    try{ window.dataLayer=window.dataLayer||[]; var _e={event:'compare_add',surface:'card',category:c,handle:h,added:added}; window.dataLayer.push(_e); if(typeof window.gtag==='function') window.gtag('event','compare_add',{surface:'card',category:c,handle:h,added:added}); }catch(_){}
  });
  function init(){ updateCards(); updateBars(); updatePill(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
